import { useDispatch } from "react-redux";

import { closeModal } from "libs/modals";
import { deleteSearchParamWhenCloseModal } from "libs/modals/init";

import { UserSheet } from "../user-sheet";
import { ADD_USER_MODAL } from "../../UserModals";

/**
 * Thin wrapper so Redux-dispatched `openModal({type: ADD_USER_MODAL})`
 * entry points (e.g. the header Add-New dropdowns) still work — they now
 * render the new right-hand {@link UserSheet} in create mode.
 */
export const AddUserModal = (): JSX.Element => {
  const dispatch = useDispatch();
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      deleteSearchParamWhenCloseModal(ADD_USER_MODAL);
      dispatch(closeModal({ type: ADD_USER_MODAL }));
    }
  };
  return <UserSheet open mode="create" onOpenChange={handleOpenChange} />;
};
